function openTab(evt, tabName, tabWrapper) {
  const wrapper = document.getElementById(tabWrapper);
  if (!wrapper) return;

  const panels = wrapper.querySelectorAll('.main-product__tab-content');
  const tabs = wrapper.querySelectorAll('.main-product__tab');

  panels.forEach(panel => {
    const active = panel.id === tabName;
    panel.hidden = !active;
    panel.style.display = active ? 'block' : 'none';
  });

  tabs.forEach(tab => {
    const active = tab.getAttribute('aria-controls') === tabName;
    tab.classList.toggle('active', active);
    tab.setAttribute('aria-selected', active ? 'true' : 'false');
    tab.setAttribute('tabindex', active ? '0' : '-1');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.main-product__tabs-wrapper').forEach(wrapper => {
    const tabs = Array.from(wrapper.querySelectorAll('.main-product__tab'));
    if (!tabs.length) return;
    const initial = wrapper.querySelector('.main-product__tab[data-default-open]') || tabs[0];
    openTab({ currentTarget: initial }, initial.getAttribute('aria-controls'), wrapper.id);

    tabs.forEach((tab, index) => {
      tab.addEventListener('keydown', event => {
        let i = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') i = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') i = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') i = 0;
        if (event.key === 'End') i = tabs.length - 1;
        if (i === null) return;
        event.preventDefault();
        const next = tabs[i];
        openTab({ currentTarget: next }, next.getAttribute('aria-controls'), wrapper.id);
        next.focus();
      });
    });
  });
});
